// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__20ExM","header":"MergedInvoice_header__1v4-i"};